import React, {useState, useRef, useCallback, useEffect} from 'react'
import {smiles} from '../../../constants';
import {i_smile} from "../../../icons";
import {TextareaChat} from "../../textarea/TextareaChat";

export function ActionNodeWaiting({form, errors, loading, setForm}) {
    const inputRef = useRef();

    const [waitTypes] = useState([
      { key: "phone", text: "Телефон", value: "phone" },
      { key: "weekday", text: "Время просыпания в рабочие дни", value: "weekday" },
      { key: "weekend", text: "Время просыпания в выходные дни", value: "weekend" },
    ]);

    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.value = form.message || '';
      }
    }, []);
  
    const handleChangeForm = useCallback((e) => {
      const name = e.target.name;
      const value = e.target.value;
      setForm({...form, [name]: value});
    }, [form, setForm]);
  
    const handleSmile = (e) => {
      insertToMessage(e.target.value);
    };
  
    const insertToMessage = (value) => {
      if (inputRef.current.value.length + value.length > 4096) {
        return;
      }
      const current = inputRef.current.value;
      const position = inputRef.current.selectionStart;
      inputRef.current.value = current.substring(0, position) +
          value +
          current.substring(position, current.length);
      inputRef.current.focus();
      inputRef.current.setSelectionRange(position + value.length, position + value.length);
      setForm({...form, message: inputRef.current.value});
    };
  
    const handleMessageChange = (e) => {
      setForm({...form, message: inputRef.current.value});
    };
  
    return <div className="modal__scroll">
      <div className="profile__group">
        <label className="profile__label help">Отправлять 1 раз в N часов</label>
        <input type="number" name="send_hour_limit" value={form.send_hour_limit} onChange={handleChangeForm} className="profile__input input" />
      </div>

      <div className="profile__wrap"> 
        <div className="profile__group">
          <label className="profile__label help">Тип ожидания</label>
          <select 
            className={`dropdown__select select ${errors.wait_type ? 'is-invalid' : ''}`}
            name="wait_type"
            value={form.wait_type}
            onChange={handleChangeForm}
          >
            {waitTypes.map(option => (
              <option key={option.value} value={option.value}>{option.text}</option>
            ))}
          </select>
        </div>
      </div>
  
      <div className="chat-panel__inner">
        <TextareaChat inputRef={inputRef} loading={loading} placeholder="Написать..." minHeight={104} 
            handleSubmit={() => {}}
            handleChange={handleMessageChange}
            />
        <button type="button" className="chat-panel__icon">
          {i_smile()}
          <ul className="dropdown dropdown--top dropdown--flex">
            {smiles.map((i, k) => <li key={k} className="dropdown__item">
              <input type="button" value={i} className="dropdown__smile" onClick={handleSmile} />
            </li>)}
          </ul>
        </button>
      </div>
      <div className="template">
        <button type="button" className="template__item" onClick={() => insertToMessage('{real_name}')}>real_name</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{day}')}>day</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{stage}')}>stage</button>
        <button type="button" className="template__item" onClick={() => insertToMessage('{course_name}')}>course_name</button>
      </div>
    </div>
  }